import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=52d00e42&scoped=true&"
import script from "./Resource.vue?vue&type=script&lang=ts&"
export * from "./Resource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d00e42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardActions})
